/* eslint-disable no-param-reassign */
import { TTooltip } from './types';
import { Box, ThemeUICSSObject } from '@apia/theme';
import { getVariant } from '@apia/theme';
import { calculateTooltipPosition, useHandlers } from './util';

export const Tooltip = ({
  anchorPoint,
  attachToElement,
  attachToElementAnchorPoint,
  attachToMousePosition,
  children,
  className,
  closeOnClick = false,
  closeOnClickOut = true,
  closeOnEscape = true,
  closeOnMouseLeaveTooltip = true,
  closeOnMouseLeaveAttachedElement = true,
  closeOnScrollOut = true,
  minSize,
  onClose,
  preferredOrientationX = 'right',
  preferredOrientationY = 'bottom',
  preferredSize = { height: 'auto', width: 'auto' },
  variant = 'layout.common.tooltips.primary',
  closeOthers,
  initialFocusGetter,
  ...dataset
}: TTooltip) => {
  const calculatedPosition = calculateTooltipPosition({
    anchorPoint,
    attachToElement,
    attachToElementAnchorPoint,
    attachToMousePosition,
    minSize,
    preferredOrientationX,
    preferredOrientationY,
    preferredSize,
  });

  const sx = {
    position: 'fixed',
    ...calculatedPosition,
  } as ThemeUICSSObject;

  const { handleOnClick } = useHandlers({
    attachToElement,
    closeOnEscape,
    closeOnClickOut,
    closeOnClick,
    closeOnMouseLeaveTooltip,
    closeOnMouseLeaveAttachedElement,
    closeOnScrollOut,
    onClose,
  });

  return (
    <Box
      {...dataset}
      className={`tooltip__wrapper ${className ?? ''}`}
      {...getVariant(variant)}
      sx={sx}
      onClick={handleOnClick}
      ref={(el) => {
        if (el) {
          initialFocusGetter?.(el)?.focus();
        }
      }}
    >
      {children}
    </Box>
  );
};
